import { APP_LOCALES, type AppLocale } from '../i18n/catalog';
import { useI18n } from '../i18n/I18nContext';

export const LanguageSelector = ({ compact = false }: { compact?: boolean }) => {
  const { locale, setLocale, t } = useI18n();
  const labels: Record<AppLocale, string> = {
    'fr-FR': t('language.fr'),
    en: t('language.en'),
    'en-XA': t('language.pseudo'),
  };
  return (
    <label className={`language-selector${compact ? ' language-selector--compact' : ''}`}>
      <span>{t('language.label')}</span>
      <select value={locale} onChange={(event) => setLocale(event.target.value as AppLocale)}>
        {APP_LOCALES.map((value) => <option key={value} value={value}>{labels[value]}</option>)}
      </select>
    </label>
  );
};
